import React from "react"

const BlockColumns = ({title, proposito, mision, vision, valores }) => {
  return (
    <div className="blockColumns-container">
      <div className="title">
       {title}
      </div>
      <div className="columns">
          <div className="column">
              <div className="title">{proposito.title}</div>
              <div className="description">{proposito.description}</div>
          </div>
          <div className="column">
              <div className="title">{mision.title}</div>
              <div className="description">{mision.description}</div>
          </div>
          <div className="column">
              <div className="title">{vision.title}</div>
              <div className="description">{vision.description}</div>
          </div>
          <div className="column">
              <div className="title">{valores.title}</div>
              <ul className="description">{valores.description.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
      </div>
    </div>
  )
}

export default BlockColumns
